// components/sections/add/button-add-section/button-add-section.styles.jsx
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: block;
`;

export const Select = styled.select`
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
`;

export const Option = styled.option``;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1rem;
`;

export const AddButton = styled.button`
  background-color: black;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.5rem 1rem;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: #333;
  }

  svg {
    font-size: 0.9rem;
  }
`;